



































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetShixunReport$, GetUserInfo$ } from "@/request/shezhenjiaoxue";
import wordcloud from "vue-wordcloud";
@Component({
  components: {
    wordcloud,
  },
})
export default class SzsxReport extends Vue {
  private user: any = {};
  private result: any = {};
  private xuexi: any = {
    series: [
      {
        type: "pie",
        data: [],
        radius: ["70%", "90%"],
        startAngel: 270,
        color: ["#99CD1B", "#D7DADB"],
        label: {
          position: "center",
          formatter: (params) => {
            if (!params["name"]) {
              return "";
            } else {
              return params["name"] + "\n" + params["percent"] + "%";
            }
          },
          fontSize: 16,
        },
      },
    ],
  };
  private moni: any = {
    tooltip: {},
    dataZoom: [
      {
        xAxisIndex: 0,
      },
    ],
    xAxis: {
      type: "category",
      data: [],
    },
    yAxis: {
      type: "value",
    },
    grid: {},
    series: [
      {
        type: "line",
        data: [],
        lineStyle: {
          color: "#52E0EB",
        },
        itemStyle: {
          color: "#52E0EB",
        },
        areaStyle: {
          color: "#EEFBFC",
        },
        smooth: true,
      },
    ],
  };
  private zhishidian: any = {};
  private cloudLoaded: boolean = false;
  private blueColor: any[] = ["#1293D1"];

  private fetchUser() {
    GetUserInfo$(this).then((data: any) => {
      this.user = data;
    });
  }

  /**
   * @description 获得结果
   */
  private fetchResult() {
    GetShixunReport$(this).then((data: any) => {
      // console.log(data);
      this.result = data;
      this.createXuexi();
      this.createMoni();
      this.createCiyun();
    });
  }

  /**
   * @description 创建学习饼图
   */
  private createXuexi() {
    this.xuexi["series"][0]["data"] = [
      {
        name: "已完成",
        value: this.result["已答题"] / this.result["总题量"],
      },
      {
        name: "",
        value: 1 - this.result["已答题"] / this.result["总题量"],
      },
    ];
  }

  /**
   * @description 创建模拟学习折线图
   */
  private createMoni() {
    this.moni["xAxis"]["data"] = this.result["测试统计"]["name"];
    this.moni["series"][0]["data"] = this.result["测试统计"]["data"];
  }
  /**
   * @description 生成词云
   */
  private createCiyun() {
    this.cloudLoaded = true;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchUser();
    this.fetchResult();
  }
}
